export const SERVICES = [
  {
    id: "mutual-funds",
    tag: "01",
    title: "Mutual Funds",
    line: "Invest systematically. Build long-term wealth.",
    points: ["SIP", "Lump Sum", "ELSS", "Goal-based investing"],
    cta: "Explore Mutual Funds",
    icon: "TrendingUp",
  },
  {
    id: "fixed-income",
    tag: "02",
    title: "Fixed Income",
    line: "Steady, predictable income to balance your portfolio.",
    points: ["Corporate Bonds", "Senior Secured Bonds", "Government Bonds", "Fixed Deposits", "REITs"],
    icon: "Landmark",
  },
  {
    id: "investments",
    tag: "03",
    title: "Investments",
    line: "Make informed investment decisions with a long-term perspective.",
    points: ["Portfolio construction", "Diversification", "Periodic reviews"],
    icon: "LineChart",
  },
  {
    id: "insurance",
    tag: "04",
    title: "Insurance",
    line: "Protect the wealth you're building.",
    points: ["Life Insurance", "Term Insurance", "Health Insurance", "General Insurance"],
    icon: "ShieldCheck",
  },
  {
    id: "tax-planning",
    tag: "05",
    title: "Tax Planning",
    line: "Reduce avoidable tax and plan your finances smarter.",
    points: ["Regime comparison", "Deductions", "Tax-efficient investing"],
    icon: "ReceiptText",
  },
  {
    id: "financial-planning",
    tag: "06",
    title: "Financial Planning",
    line: "Turn your financial goals into an actionable plan.",
    points: ["Retirement", "Children's education", "Wealth creation", "Corpus planning"],
    icon: "Target",
  },
  {
    id: "loans",
    tag: "07",
    title: "Loans",
    line: "Borrow sensibly — arranged through our lending partners.",
    points: ["Home Loan", "Loan Against Property", "Business Loan", "Loan Against Securities"],
    icon: "HandCoins",
    badge: "Via lending partners",
  },
  {
    id: "advanced",
    tag: "08",
    title: "Advanced Investments",
    line: "Explore opportunities beyond traditional investments.",
    points: ["Unlisted Equities", "AIF", "Portfolio Management"],
    icon: "Gem",
  },
];

export const MARQUEE_WORDS = ["Mutual Funds", "Fixed Income", "Bonds & FDs", "Insurance", "Tax Planning", "Financial Planning", "Loans", "REITs", "Unlisted Equities", "AIF"];

export const AUDIENCE = [
  {
    id: "starting-out",
    title: "Starting Out",
    line: "Just started earning and don't know where to begin?",
    img: "https://images.unsplash.com/photo-1686984096026-23d6e82f9749?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHx5b3VuZyUyMGluZGlhbiUyMHByb2Zlc3Npb25hbCUyMHdvcmtpbmclMjBsYXB0b3B8ZW58MHx8fHwxNzg2MTcxMDM2fDA&ixlib=rb-4.1.0&q=85",
    alt: "Young Indian professional starting their investment journey",
  },
  {
    id: "growing-wealth",
    title: "Growing Wealth",
    line: "Already investing but want a more structured strategy?",
    img: "https://images.unsplash.com/photo-1656236607879-cd489955e17b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxiZW5nYWxpJTIwcHJvZmVzc2lvbmFsJTIwd29tYW4lMjB3b3JraW5nJTIwb2ZmaWNlJTIwa29sa2F0YXxlbnwwfHx8fDE3ODYxNzEyMTZ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Bengali professional reviewing investments on a tablet",
  },
  {
    id: "protecting-family",
    title: "Protecting Your Family",
    line: "Want to make sure your family's financial future is protected?",
    img: "https://images.unsplash.com/photo-1780329946888-0db2441b249c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBmYW1pbHklMjBob21lJTIwZmluYW5jaWFsJTIwc2VjdXJpdHl8ZW58MHx8fHwxNzg2MTcxMDM1fDA&ixlib=rb-4.1.0&q=85",
    alt: "Indian family planning a secure financial future",
  },
  {
    id: "serious-wealth",
    title: "Building Serious Wealth",
    line: "Looking for more advanced opportunities and better financial planning?",
    img: "https://images.unsplash.com/photo-1706074793638-da28b90ea8ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBwcm9mZXNzaW9uYWwlMjBtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzg2MTcwOTUyfDA&ixlib=rb-4.1.0&q=85",
    alt: "Professional exploring advanced wealth-building opportunities",
  },
];

export const STEPS = [
  {
    num: "01",
    title: "Tell Us About Your Goals",
    line: "Share your income, goals, existing investments and priorities.",
  },
  {
    num: "02",
    title: "Get a Personalised Strategy",
    line: "Our team evaluates your situation and helps create an appropriate financial approach.",
  },
  {
    num: "03",
    title: "Start With Confidence",
    line: "Implement your strategy and review it as your goals and circumstances evolve.",
  },
];

export const WHY = [
  { title: "Personalised", line: "Your financial strategy should reflect your goals, not a generic template.", icon: "UserRoundCog" },
  { title: "Holistic", line: "Look beyond individual products and consider investments, protection and planning together.", icon: "Layers" },
  { title: "Transparent", line: "Clear communication without unnecessary complexity.", icon: "Eye" },
  { title: "Long-Term", line: "Focus on sustainable wealth creation rather than short-term hype.", icon: "Hourglass" },
];

export const IG_POSTS = [
  { topic: "SIP Basics", caption: "How SIPs turn small, regular amounts into a long-term habit.", accent: "royal", icon: "PiggyBank", img: "https://images.unsplash.com/photo-1565373679107-344d38dbf734?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxwZXJzb25hbCUyMGZpbmFuY2UlMjBpbnZlc3RtZW50JTIwc2F2aW5ncyUyMGNvbmNlcHQlMjBpbmRpYXxlbnwwfHx8fDE3ODYxNzQ0MDB8MA&ixlib=rb-4.1.0&q=85", alt: "Indian rupee coins and notes representing systematic saving" },
  { topic: "Tax Smart", caption: "Simple ways to plan for tax before the year-end rush.", accent: "gold", icon: "ReceiptText", img: "https://images.unsplash.com/photo-1565372594646-7e38ab4547c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxwZXJzb25hbCUyMGZpbmFuY2UlMjBpbnZlc3RtZW50JTIwc2F2aW5ncyUyMGNvbmNlcHQlMjBpbmRpYXxlbnwwfHx8fDE3ODYxNzQ0MDB8MA&ixlib=rb-4.1.0&q=85", alt: "Indian rupee notes and coins for tax planning" },
  { topic: "Protection 101", caption: "Term vs. life insurance — what actually protects your family.", accent: "navy", icon: "ShieldCheck", img: "https://images.unsplash.com/photo-1565374392032-8007fb37c26e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxwZXJzb25hbCUyMGZpbmFuY2UlMjBpbnZlc3RtZW50JTIwc2F2aW5ncyUyMGNvbmNlcHQlMjBpbmRpYXxlbnwwfHx8fDE3ODYxNzQ0MDB8MA&ixlib=rb-4.1.0&q=85", alt: "Indian rupee banknotes arranged around a coin" },
];

export const FOUNDERS = [
  {
    name: "Rohan Kumar Sarbadhikari",
    role: "Co-Founder",
    initials: "RS",
    photo: "/founder-b.jpeg",
    arn: "ARN-354104",
    bse: "BSE Member Code 66455",
  },
  {
    name: "Madhurima Das",
    role: "Co-Founder",
    initials: "MD",
    photo: "/founder-a.webp",
    arn: "ARN-354103",
    bse: "BSE Member Code 66403",
  },
];

export const FAQS = [
  { q: "What does Auxieron do?", a: "Auxieron is a single partner for your financial life. We guide you across mutual funds, fixed income (bonds, FDs, REITs), insurance, tax planning, loans and long-term financial planning — all built around your personal goals." },
  { q: "Is Auxieron suitable for first-time investors?", a: "Yes. Whether you have just started earning or are unsure where to begin, we help you understand your options and take a sensible first step, without pressure." },
  { q: "Do I need a large amount of money to get started?", a: "No. You can begin with an amount you're comfortable with. What matters more is starting with a clear plan and staying consistent over time." },
  { q: "Does Auxieron provide loans?", a: "Auxieron is not a lender. We help you decide whether a loan fits your plan and then arrange it through our network of lending partners — home loans, loans against property, business loans and loans against securities. The credit decision and terms rest with the lending partner." },
  { q: "What fixed-income options do you offer?", a: "Corporate bonds, senior secured bonds, government bonds and G-Secs, fixed deposits and listed REITs. We help you weigh credit quality, tenure and taxation so the stable part of your portfolio stays stable." },
  { q: "What financial products do you provide?", a: "Mutual funds, fixed income, insurance, tax planning, financial planning, loans (via lending partners), portfolio management, unlisted equities and Alternative Investment Funds (AIF)." },
  { q: "How do I get a personalised financial plan?", a: "Share a few details through the enquiry form. Our team will review your situation and reach out to help you identify the right place to begin." },
  { q: "How does the consultation process work?", a: "It's a simple three-step process — you tell us about your goals, we evaluate your situation and suggest an appropriate approach, and then you start with confidence and review it over time." },
];
